import { render, staticRenderFns } from "./ShieldAboutServices.vue?vue&type=template&id=5628afd9&scoped=true&"
import script from "./ShieldAboutServices.vue?vue&type=script&lang=js&"
export * from "./ShieldAboutServices.vue?vue&type=script&lang=js&"
import style0 from "./ShieldAboutServices.vue?vue&type=style&index=0&id=5628afd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5628afd9",
  null
  
)

export default component.exports